/*@ngInject*/
const FormComponentUtil = function (xmlUtil, localization, numberFilter, currencyFilter, coreMediator, appTypeConfigurationModel, editableFieldLevel, currencyUtil, fieldType, preferenceModel) {

    let TOOLTIP_POPOVER = 'tooltipPopover',
        ERROR_POPOVER = 'errorPopover',
        errorDelay = 50,
        tooltipDelay = 500,
        shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat'),
        translations = {};

    localization.getTranslations().then(function (result) {
        translations = result;
    });

    this.buildLayoutProperties = function (uiField, groupItems) {
        const isLeftAligned = uiField.labelAlignment === 'left',
            isCheckbox = uiField.fieldTemplate.type === fieldType.CHECK_BOX,
            result = {};

        result.labelWidth = uiField.labelWidth;
        result.isLabelLeftAligned = isLeftAligned;
        result.inputWidth = isCheckbox ? 65 : uiField.minWidth;
        result.inputHeight = uiField.height;
        result.hasBusinessCard = uiField.hasBusinessCard;
        result.hasOrganizationCard = uiField.hasOrganizationCard;

        return result;
    };

    this.getGroupItemWidth = function (layout, groupItems) {
        let groupItemWidth = 0;

        if (layout.inputWidth > 0 && groupItems && groupItems.length > 0) {
            let maxLengthString = '', itemWidth;
            _.each(groupItems, function (groupItem) {
                if (!_.isEmpty(groupItem) && groupItem.name.length > maxLengthString.length) {

                    //make sure the length is really the longer, based on characters width
                    itemWidth = getTextWidth(groupItem.name, null);
                    if (itemWidth > groupItemWidth) {
                        maxLengthString = groupItem.name;
                        groupItemWidth = itemWidth;
                    }
                }
            });

            groupItemWidth = _.toString(groupItemWidth + 32) + 'px';
        } else {
            groupItemWidth = '';
        }

        return groupItemWidth;
    };

    /**
     * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
     *
     * @param {String} text The text to be rendered.
     * @param {String} font The css font descriptor that text is to be rendered with (e.g. 'bold 14px verdana').
     *
     * @see http://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
     */
    function getTextWidth(text, font) {
        // re-use canvas object for better performance
        let canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
        let context = canvas.getContext('2d');
        context.font = font ? font : '11px Arial';
        let metrics = context.measureText(text);
        return metrics.width;
    }

    this.isFieldRequired = function (form, fieldModel, fieldTemplate) {
        let requiredFieldLevel = fieldModel && fieldModel.requiredFieldLevel >= 0 ? fieldModel.requiredFieldLevel : fieldTemplate.requiredFieldLevel;
        return (requiredFieldLevel > 0 && requiredFieldLevel <= form.requiredFieldLevel);
    };

    this.isValidField = function (fieldModel) {
        let result = true;

        if (fieldModel) {
            result = fieldModel.valid !== false;
        }

        return result;
    };

    this.isFieldDisabled = function (form, fieldInstance, fieldTemplate, hasWriteAccess) {
        let isFieldDisabled = fieldInstance ? fieldInstance.disabled : false,
            fieldTemplateEditableFieldLevel = appTypeConfigurationModel.isUnderwriterWorkstation() ? fieldTemplate.carrierEditableFieldLevel : fieldTemplate.agencyEditableFieldLevel,
            isFieldLevelDisabled = form.editableFieldLevel > fieldTemplateEditableFieldLevel && fieldTemplateEditableFieldLevel !== editableFieldLevel.ALWAYS_EDITABLE,
            isFormDisabled = isFieldLevelDisabled || form.readOnly || form.printPreview;

        return isFieldDisabled || isFormDisabled || !hasWriteAccess;
    };

    this.isFieldHidden = function (fieldInstance, fieldTemplate) {
        let result = false,
            templateHiddenForUserType = appTypeConfigurationModel.isUnderwriterWorkstation() ? !fieldTemplate.carrierVisible : !fieldTemplate.agencyVisible;

        if (templateHiddenForUserType) {
            result = true;
        } else {
            if (fieldTemplate.hidden) {
                result = true;
            }

            if (fieldInstance && fieldInstance.hidden) {
                result = true;
            } else if (fieldInstance && !fieldInstance.hidden) {
                result = false;
            }
        }

        return result;
    };

    this.getTooltip = function (fieldInstance, uiField, hasChanges, currencyCode) {
        let result,
            errorMessage = this.getErrorMessage(fieldInstance, uiField, hasChanges, currencyCode);

        if (errorMessage) {
            result = {
                type: ERROR_POPOVER,
                delay: errorDelay,
                message: errorMessage
            };
        } else {
            result = {
                type: TOOLTIP_POPOVER,
                delay: tooltipDelay,
                message: uiField.tooltipText
            };
        }

        return result;
    };

    this.setupFieldProperties = function (fieldStructure, currencyCode) {
        if (fieldStructure) {
            let form = fieldStructure.parentForm,
                uiField = fieldStructure.uiField,
                fieldInstance = fieldStructure.fieldModel,
                fieldTemplate = fieldStructure.uiField.fieldTemplate;

            fieldStructure.dynamicProperties = {};

            fieldStructure.dynamicProperties.hasValue = fieldInstance ? !_.isEmpty(fieldInstance.value) : false;

            fieldStructure.dynamicProperties.isRequired = this.isFieldRequired(form, fieldInstance, fieldTemplate);
            fieldStructure.dynamicProperties.isValid = this.isValidField(fieldInstance);
            fieldStructure.dynamicProperties.disabled = this.isFieldDisabled(form, fieldInstance, fieldTemplate, form.hasWriteAccess);
            fieldStructure.dynamicProperties.hidden = this.isFieldHidden(fieldInstance, fieldTemplate);
            fieldStructure.dynamicProperties.tooltip = this.getTooltip(fieldInstance, uiField, fieldStructure.hasLocalChanges, currencyCode);
            fieldStructure.layout = this.buildLayoutProperties(uiField);

            fieldStructure.requiredIndicatorLabelConfig = {
                required: fieldStructure.dynamicProperties.isRequired,
                valid: fieldStructure.dynamicProperties.isValid,
                hasValue: fieldStructure.dynamicProperties.hasValue,
                label: fieldStructure.uiField.displayLabel,
                width: fieldStructure.layout.labelWidth,
                bold: _.toLower(uiField.labelFontStyle) === 'bold',
                variableName: fieldStructure.uiField.fieldTemplate.variableName
            };
        }
    };

    this.getErrorMessage = function (fieldInstance, uiField, hasLocalChanges, currencyCode) {
        let errorCode = fieldInstance ? fieldInstance.validationErrorCode : -1,
            errorMessage,
            dynamicMessageValues = xmlUtil.parseString(uiField.fieldTemplate.validatorProperty),
            tooltip = uiField.tooltipText,
            fieldValidator = uiField.fieldTemplate.validator;

        function processRangeMessage() {
            // Handle cases where fromNum isn't defined, defaulting to 0
            let fromNum = dynamicMessageValues.fromNum || '0',
                toNum = dynamicMessageValues.toNum,
                currencyFormat = currencyUtil.getCurrencyFormat(currencyCode);

            if (fieldValidator === 'currency') {
                fromNum = currencyFilter(parseInt(fromNum), currencyFormat.symbol, 0, currencyFormat.suffixSymbol, currencyFormat.customFormat);
                toNum = currencyFilter(parseInt(toNum), currencyFormat.symbol, 0, currencyFormat.suffixSymbol, currencyFormat.customFormat);
            } else {
                if (!_.isNil(fromNum)) {
                    fromNum = numberFormatter(fromNum);
                }
                if (!_.isNil(toNum)) {
                    toNum = numberFormatter(toNum);
                }
            }

            errorMessage = _.replace(errorMessage, '{0}', fromNum);
            errorMessage = _.replace(errorMessage, '{1}', toNum);
        }

        function buildMessage() {
            errorMessage = _.get(translations, 'formsViewer.errors.' + errorCode) || '';

            if (errorCode === 'noMatch' && tooltip) {
                errorMessage = errorMessage + ' - ' + tooltip;
            } else if (errorMessage) {
                errorMessage = errorMessage + '.';
            }
        }

        function processDynamicValues() {
            switch (errorCode) {
                case 'amountOutOfRange':
                case 'numberOutOfRange':
                case 'percentageOutOfRange':
                    processRangeMessage();
                    break;
                case 'wrongDateFormat':
                    errorMessage = _.replace(errorMessage, '{0}', shortDateFormat);
                    break;
            }
        }

        function numberFormatter(number) {
            number = parseFloat(number).toString();
            if (number.indexOf('.') !== -1) {
                let numberWithDecimal = _.split(number, '.');
                /* Specific scenario to handle tooltip when number range validator is given like -0.01.
                Numberfilter is changing -0 to 0 and it results in wrong tooltip. To avoid this, -0 is being skipped from formatting*/
                if (numberWithDecimal[0] !== '-0') {
                    numberWithDecimal[0] = numberFilter(numberWithDecimal[0], 0);
                }
                number = numberWithDecimal[0] + '.' + numberWithDecimal[1];
            } else {
                number = numberFilter(number, 0);

            }
            return number;
        }

        buildMessage();
        processDynamicValues();

        return errorMessage;
    };

    this.formatDateWithDefaultPreferences = function (date, isAmPm, utc) {
        let isValid = (date) ? moment(new Date(date)).isValid() : false,
            result = date,
            formatWith = (isAmPm) ? shortDateFormat + ' hh:mm A' : shortDateFormat,
            momentObject;

        if (isValid) {
            momentObject = moment(new Date(date));

            if (utc) {
                momentObject = momentObject.utc();
            }

            result = momentObject.format(formatWith);
        } else {
            result = undefined;
        }

        return result;
    };

    this.parseDateWithDefaultPreferences = function (date, isAmPm, utc) {
        let dateArray,
            momentObject;

        if (shortDateFormat === 'DD/MM/YYYY') {
            dateArray = _.split(date, '/');
            date = dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2];
        }

        let formatWith = (isAmPm) ? shortDateFormat + ' hh:mm A' : shortDateFormat,
            isValid = moment(date, formatWith).isValid() &&
                moment(new Date(date)).isAfter('1900-01-01T12:00:00Z') &&
                moment(new Date(date)).isBefore('2100-01-01T12:00:00Z') &&
                date.length >= 8,
            result = date;

        if (isValid) {
            momentObject = moment(new Date(date));

            if (utc) {
                momentObject = momentObject.utc();
            }

            result = momentObject.format(formatWith);
        } else {
            result = undefined;
        }

        return result;
    };

    this.formatDateForServer = function (date, isAmPm, utc) {
        let isValid = (date) ? moment(new Date(date)).isValid() : false,
            result = date,
            formatWith = (isAmPm) ? 'MM/DD/YYYY hh:mm A ZZ' : 'MM/DD/YYYY',
            momentObject;

        if (isValid) {
            momentObject = moment(new Date(date));

            if (utc) {
                momentObject = momentObject.utc();
            }

            result = momentObject.format(formatWith);
        } else {
            result = undefined;
        }

        return result;
    };

    this.formatCurrencyForRounding = function (value) {
        let currencySeparatorIsPeriod = preferenceModel.get('view.currencySeparator'),
            //Only remove $ if found, otherwise invalid, other symbols for the preference 'system.currencyCode' are not supported
            valueWithoutCurrencySymbol = value.substring(0,1) === '$' ? value.substring(1):value,
            //2nd find currency separator and if currency separator is in value format (matches regEX looking for separators for valid currency format)
            isValidCurrencyFormat = (currencySeparatorIsPeriod === 'true') ? !!valueWithoutCurrencySymbol.match(/(?=.*?\d)^\$?(([1-9]\d{0,2}(\.\d{3})*)|\d+)?(,\d{1,2})?$/) : !!valueWithoutCurrencySymbol.match(/(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/),
            modifiedValue;
        if (currencySeparatorIsPeriod === 'true') {
            //only allow numbers and commas(decimal points)
            modifiedValue = isValidCurrencyFormat ? value.replace(/[^0-9,]/g, ""):value;
        }else{
            //only allow numbers and periods(decimal points)
            modifiedValue = isValidCurrencyFormat ? value.replace(/[^0-9.]/g, ""):value;
        }
        return modifiedValue;
    };

    this.roundCurrencyForServer = function (value, rounding) {
        let modifiedValue = this.formatCurrencyForRounding(value);
        if (!_.isEmpty(modifiedValue) && !isNaN(modifiedValue)) {
            switch (rounding) {
                case 'nearest':
                    modifiedValue = Math.round(modifiedValue);
                    break;
                case 'up':
                    modifiedValue = Math.ceil(modifiedValue);
                    break;
                case 'down':
                    modifiedValue = Math.floor(modifiedValue);
                    break;
            }
        }

        return modifiedValue;
    };

    this.parseDateFromServer = function (date, isAmPm, utc) {
        let formatWith = (isAmPm) ? 'MM/DD/YYYY hh:mm A ZZ' : 'MM/DD/YYYY',
            isValid = moment(date, formatWith).isValid() &&
                moment(date, formatWith).isAfter('1900-01-01T12:00:00Z') &&
                moment(date, formatWith).isBefore('2100-01-01T12:00:00Z') &&
                date.length >= 8,
            result = date,
            momentObject;

        if (isValid) {
            momentObject = moment(date, formatWith);

            if (utc) {
                momentObject = momentObject.utc();
            }

            result = momentObject.toDate();
        } else {
            result = undefined;
        }

        return result;
    };

    this.dateFromInput = function (date, isAmPm, utc) {
        let yyyyDateFormat = (shortDateFormat === 'MM/DD/YY') ? 'MM/DD/YYYY' : shortDateFormat,
            formatWith = (isAmPm) ? yyyyDateFormat + ' hh:mm A' : yyyyDateFormat,
            isValid = moment(date, formatWith).isValid() &&
                moment(date, formatWith).isAfter('1900-01-01T12:00:00Z') &&
                moment(date, formatWith).isBefore('2100-01-01T12:00:00Z') &&
                date.length >= 6,
            result = date,
            momentObject;

        if (isValid) {
            momentObject = moment(date, formatWith);

            if (utc) {
                momentObject = momentObject.utc();
            }

            result = momentObject.toDate();
        } else {
            result = undefined;
        }

        return result;
    };

    this.getIndexedFieldName = function (uiField, isRowRepeater, rowModel) {
        return uiField.fieldTemplate.variableName + ((isRowRepeater && rowModel.rowNumber > 0) ? ':' + rowModel.rowNumber : '');
    };
};

angular.module('umFormViewer')
    .service('formComponentUtil', FormComponentUtil);
